import { useLab, useOrder } from '@hook'
import { BinIcon } from '@icons'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { hideDeleteLab } from '@store/slicers/ModalSlicer'
import { Button, DeleteModal, ModalHeader } from '@ui'
import { getError, showToast } from '@util'
import { Box, Heading, Layer, Text } from 'grommet'
import { Checkmark, Close } from 'grommet-icons'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

export const DeleteLabOrder = () => {
  const dispatch = useAppDispatch()
  const { id } = useAppSelector(state => state.modal.lab.delete)
  const { patientId } = useParams<string>()
  const { deleteLab } = useLab({ patientId })
  const [loading, setLoading] = useState(false)
  const onClose = () => {
    dispatch(hideDeleteLab())
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await deleteLab({ id })
      showToast('Lab Order deleted successfully')
      onClose()
    } catch (err) {
      getError(err)
    }
    setLoading(false)
  }
  return (
    <Layer modal onClickOutside={onClose} onEsc={onClose} position="center" style={{ borderRadius: '15px' }}>
      <Box align="center" justify="center" pad="medium" width="430px">
        <ModalHeader onClose={onClose} pad="0" />
        <Box align="center" justify="center" margin={{ bottom: 'small' }}>
          <BinIcon />
        </Box>
        <Box gap="small" margin={{ bottom: 'small' }} width="281px">
          <Heading color="black" level={5} margin="medium" size="20px" textAlign="center" weight="400">
            Delete Lab Order
          </Heading>
          <Text color={'#999999'} margin="small" size="14px" textAlign="center">
            Confirm that you want to delete this lab order
          </Text>
        </Box>
        <Box
          direction="row"
          flex
          gap="16px"
          justify="center"
          pad={{ horizontal: '32px', vertical: '14px' }}
          width="100%"
        >
          <Button icon={<Close size="small" />} kinds="secondary" label="No, Keep" onClick={onClose} />
          <Button icon={<Checkmark size="small" />} isLoading={loading} label="Yes, Delete" onClick={handleSubmit} />
        </Box>
      </Box>
    </Layer>
  )
}

type CancelProps = {
  onClose: () => void
  id?: string
}

export const CanceAllLabOrders = ({ onClose, id }: CancelProps) => {
  const { cancelAllOrder } = useLab()
  const [loading, setLoading] = useState(false)
  const handleSubmit = async () => {
    setLoading(true)
    try {
      await cancelAllOrder({ id: id as string })
      showToast('Lab Order cancelled successfully')
      onClose()
    } catch (err) {
      getError(err)
    }
    setLoading(false)
  }
  return (
    <DeleteModal
      description="Are you sure you want to cancel all lab orders?"
      handleSubmit={handleSubmit}
      isLoading={loading}
      onClose={onClose}
      rBtnLabel="Yes, Cancel"
      title="Cancel all lab orders"
    />
  )
}

export const CancelLabOrder = ({ onClose, id }: CancelProps) => {
  const { updateOrder } = useOrder()
  const [loading, setLoading] = useState(false)
  const handleSubmit = async () => {
    setLoading(true)
    try {
      await updateOrder({
        formVal: { data: { attributes: { status: 'cancelled', note: 'Reason or comment' }, type: 'order' } },
        id: id as string
      })
      showToast('Lab Order cancelled successfully')
      onClose()
    } catch (err) {
      getError(err)
    }
    setLoading(false)
  }
  return (
    <DeleteModal
      description="Are you sure you want to cancel this lab order?"
      handleSubmit={handleSubmit}
      isLoading={loading}
      onClose={onClose}
      rBtnLabel="Yes, Cancel"
      title="Cancel lab order"
    />
  )
}
